export const myProductsGroupType = {
  SINGLE: 'single',
  GROUP: 'group',
} as const;

// Status of update:
// 'SUCCESS';
// 'ERROR' - when not all products are found and request `allowPartialAdding=false`;
// 'PRODUCTS_UNAVAILABLE' - not found any product in catalog;.

export const myProductsResponseStatus = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
} as const;

export const myProductsAddResponseStatus = {
  ...myProductsResponseStatus,
  PRODUCTS_UNAVAILABLE: 'PRODUCTS_UNAVAILABLE',
} as const;

export const myProductsRemoveResponseStatus = { ...myProductsResponseStatus } as const;
